import { render, staticRenderFns } from "./SmartTagsResult.vue?vue&type=template&id=ec75c8ca"
import script from "./SmartTagsResult.vue?vue&type=script&lang=js"
export * from "./SmartTagsResult.vue?vue&type=script&lang=js"
import style0 from "./SmartTagsResult.vue?vue&type=style&index=0&id=ec75c8ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports